import React, { useState, useEffect } from 'react';
import constClass from '../../Constants/Constants';
import LiffTicket from '../Liff/Ticket';
import LiffTicketIssue from '../Liff/TicketIssue';
import LiffBenefit from '../Liff/Benefit';
import axios from 'axios';
import Common from '../Common/common';
import { useToasts } from 'react-toast-notifications';
import UseConfirmModal from '../Common/UseConfirmModal';
import Loading from '../Loading/Loading';
import PointBreakdown from '../Common/PointBreakdown';
import { v4 as uuidv4 } from 'uuid';

const style = {
  result: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    fontSize: "2.5rem",
  },
};

const Calculator = ({ setMode, appState, setAppState, setQrCodeData, siteId, gotoPointHistory, resetCamera, ticketGroupMessage, setPointUuid }) => {
  const { addToast } = useToasts();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmModalMessage, setConfirmModalMessage] = useState('');
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [lockData, setLockData] = useState(false);
  const [ticketUuid, setTicketUuid] = useState(null);

  const handlePaymentMethod = (type) => {
    var state = {
      ...appState,
      paymentMethod: type,
    };
    setAppState(state);
  }
  const handleNumClick = async (n) => {
    if (appState.inputValue.toString().length >= 9) {
      console.log("integer over");
      return false;
    }
    var state = {
      ...appState,
      inputValue: appState.inputValue === 0 ? Number(n) : Number(appState.inputValue.toString() + n)
    };
    if (state.inputValue > 0) {
      const ticket = appState.resTicketList.filter(ticket => Number(ticket.specified_amount) < Number(state.inputValue));
      state = {
        ...state,
        ticketList: ticket
      };
    } else {
      state = {
        ...state,
        ticketList: null
      };
    }
    if (state.inputValue > 0 && (appState.point_rate > 0 || appState.point_base_amount > 0)) {
      var addPoint = Math.floor((appState.point_rate > 0 ? state.inputValue * (appState.point_rate / 100) : state.inputValue / appState.point_base_amount));
      if (appState.max_point > 0 && addPoint > appState.max_point) addPoint = appState.max_point;
      state = {
        ...state,
        addPoint: addPoint
      };
    }
    setAppState(state);
  }
  const handleOperatorClick = async (t) => {
    var state = {
      ...appState,
    };
    switch (t) {
      case "📷":
        setMode(constClass.POINT_SCREEN.CAMERA);
        break;
      case "⏎":
        const jwt = localStorage.getItem('jwt');
        const ticket_list = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${appState.mall_id}/amount`, { site_id: siteId, amount: state.inputValue }, {
          headers: {
            Authorization: `Bearer ${jwt}`,
          }
        })).data;
        state = {
          ...state,
          ticketList: Array.isArray(ticket_list) ? ticket_list : []
        };
        setAppState(state);
        setMode(constClass.POINT_SCREEN.DETAIL);
        break;
      case "C":
        state.inputValue = 0;
        state.addPoint = 0;
        state.ticketList = null;
        break;
      default:
    }
    setAppState(state);
  }
  const handleBackClick = () => {
    const initialAppState = {
      ...appState,
      customer_id: null,

      qrcode_err: null,
      membership_id: null,  //会員ID
      customer_name: '',    //お客様名
      available_point: 0,   //利用可能ポイント
      customer_rank: null,    //会員ランク

      inputValue: 0,      //対象金額
      pointUseFlag: null,       //ポイント利用(つかう:true,ためる:false)
      use_point: 0,   //クーポン利用のポイント
      couponUseFlag: null,
      usePoint: 0,        //利用ポイント
      paymentValue: 0,    //支払金額
      addPoint: 0,        //加算ポイント
      pointBalance: 0,    //ポイント残高

      paymentMethod: constClass.PAYMENT_METHOD.CASH,
      campaignMagnification: null,   //キャンペーン倍率
      campaignName: "",
      addBonusPoint: 0,

      ticketList: null, // 付与予定クーポン
      pointCampaignList: null, //現在開催中のキャンペーン一覧

      pointRegist: false,//ポイント付与確定
    };
    resetCamera();
    setMode(constClass.POINT_SCREEN.CAMERA);
    setAppState(initialAppState);
  }

  const Result = ({ result }) => (
    <div className="h-100">
      <span className="h-100" style={style.result}>{Number(result).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })}</span>
    </div>
  );

  const NumBtn = ({ n, className }) => (
    <button className={`${className} numbtnfont`} onClick={() => { handleNumClick(n) }}>{n}</button>
  );

  const OperatorBtn = ({ t, className, disabled }) => (
    <button disabled={disabled ?? false} className={className} onClick={() => { handleOperatorClick(t) }}>{t}</button>
  );

  const checkInvalid = () => {
    const messageCheck = ticketGroupMessage ? true : false;
    const pointCheck = (appState.available_point - appState.use_point < 0);
    var couponCheck
    if (appState.selectData.issue_count) {
      couponCheck = appState.selectData.use_date;
    } else {
      if (appState.selectData.ticket_times !== 0) {
        couponCheck = !Common.isTicketCountAvailable(appState.selectData);
      }
    }
    return pointCheck || couponCheck || messageCheck || lockData;
  }

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  var couponUseFlag = false;

  const handleCouponUseClick = async (type) => {
    if (appState.selectData.issue_count && !appState.selectData.benefit_id) {
      setConfirmModalMessage('利用してもよろしいですか？');
      setIsConfirmModalOpen(true);
      setOnConfirm(() => async () => {
        if (couponUseFlag) {
          return;
        }
        couponUseFlag = true;
        setLockData(true);
        closeConfirmModal();
        const params = {
          customer_id: appState.customer_id,
          issue_count: appState.selectData.issue_count,
          mall_id: appState.mall_id,
          shop_id: appState.shop_id,
          cashier_no: appState.cashier_no,
        };
        var res;
        try {
          const jwt = localStorage.getItem('jwt');
          res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket_issue/${siteId}/${appState.selectData.ticket_id}/use`, params, {
            headers: {
              Authorization: `Bearer ${jwt}`
            }
          });
          console.log("res");
          console.log(res);
          if (res && !res.data.result) {
            addToast(res.data.msg, { appearance: 'error', autoDismiss: true });
          }
          else {
            addToast(`${appState.use_point ? 'ポイントを利用しました。' : 'クーポンを利用しました。'}`, { appearance: 'success', autoDismiss: true });
            setMode(constClass.POINT_SCREEN.MAIN);
            var state = {
              ...appState,
              couponUseFlag: false,
            };
            setAppState(state);
          }
        } catch (err) {
          console.log("err");
          console.log(err);
          console.log(err.response);
          console.log(err.response.data);
          
          
          if (err.response.data !== null) {
            addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
          } else {
            addToast(err.response, { appearance: 'error', autoDismiss: true });
          }
        } finally {
          await refreshTicketData();
          setLockData(false);
        }
      });
    } else if (appState.selectData.benefit_id) {
      setConfirmModalMessage('利用してもよろしいですか？');
      setIsConfirmModalOpen(true);
      setOnConfirm(() => async () => {
        if (couponUseFlag) {
          return;
        }
        couponUseFlag = true;
        setLockData(true);
        closeConfirmModal();
        const params = {
          customer_id: appState.customer_id,
          benefit_id: appState.selectData.benefit_id,
          issue_count: appState.selectData.issue_count,
          mall_id: appState.mall_id,
          shop_id: appState.shop_id,
          cashier_no: appState.cashier_no,
        };
        var res;
        try {
          const jwt = localStorage.getItem('jwt');
          res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/${siteId}/${appState.selectData.benefit_id}/ticketuse`, params, {
            headers: {
              Authorization: `Bearer ${jwt}`
            }
          });
          if (res && res.data.error) {
            addToast(res.data.message, { appearance: 'error', autoDismiss: true });
          }
          else {
            addToast(`${appState.use_point ? 'ポイントを利用しました。' : 'クーポンを利用しました。'}`, { appearance: 'success', autoDismiss: true });
            setMode(constClass.POINT_SCREEN.MAIN);
            var state = {
              ...appState,
              couponUseFlag: false,
            };
            setAppState(state);
          }
        } catch (err) {
          if (err.response.data !== null) {
            addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
          } else {
            addToast(err.response, { appearance: 'error', autoDismiss: true });
          }
        } finally {
          await refreshTicketData();
          setLockData(false);
        }
      });
    } else {
      // チケットの利用回数未満の場合に実行
      if (appState.selectData.ticket_times === 0 || Common.isTicketCountAvailable(appState.selectData)) {
        setConfirmModalMessage('利用してもよろしいですか？');
        setIsConfirmModalOpen(true);
        setOnConfirm(() => async () => {
          if (couponUseFlag) {
            return;
          }
          couponUseFlag = true;
          setLockData(true);
          closeConfirmModal();
          const params = {
            customer_id: appState.customer_id,
            ticket_month: Common.getMonthString(),
            mall_id: appState.mall_id,
            shop_id: appState.shop_id,
            cashier_no: appState.cashier_no,
            ticket_uuid: ticketUuid,
          };
          var res;
          // API実行
          try {
            const jwt = localStorage.getItem('jwt');
            res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${appState.selectData.ticket_id}/use`, params, {
              headers: {
                Authorization: `Bearer ${jwt}`
              }
            });
            if (res && !res.data.result) {
              addToast(res.data.msg, { appearance: 'error', autoDismiss: true });
            }
            else {
              addToast(`${appState.use_point ? 'ポイントを利用しました。' : 'クーポンを利用しました。'}`, { appearance: 'success', autoDismiss: true });
              setMode(constClass.POINT_SCREEN.MAIN);
              var state = {
                ...appState,
                couponUseFlag: false,
              };
              setAppState(state);
            }
          } catch (err) {
            if (err.response.data !== null) {
              addToast(err.response.data, { appearance: 'error', autoDismiss: true });
            } else {
              addToast(err.response, { appearance: 'error', autoDismiss: true });
            }
          } finally {
            await refreshTicketData();
            setLockData(false);
          }
        });
      }
    }
  }

  const refreshTicketData = async () => {

    try {
      await setQrCodeData(null);
      setMode(constClass.POINT_SCREEN.MAIN);
    } catch (err) {
      setMode(constClass.POINT_SCREEN.CAMERA);
    }
  };
  
  useEffect(() => {    
    setPointUuid(uuidv4());
    setTicketUuid(uuidv4());
  }, [setPointUuid]);

  return (
    <div>
      {lockData && <Loading />}
      <div className="row">
        <div className="col text-center">
          <span>会員証・クーポン読み取り</span>
        </div>
      </div>
      <UseConfirmModal isOpen={isConfirmModalOpen} message={confirmModalMessage} onConfirm={onConfirm} onClose={closeConfirmModal} disabled={lockData} />
      {!appState.couponUseFlag &&
        <React.Fragment>
          <div className="row col-12">
            <div className='col-2'>
              <button type="button"
                className={`btn btn-secondary mx-1 w-100 text-nowrap`}
                onClick={() => { handleBackClick() }}>
                戻る
              </button>
            </div>
          </div>
          <div className="row">
            <div className="half full my-3 text-left bg-white mx-4">
              <div className="row">
                <div className="col my-3 text-left bg-white">
                  <div className="card-header p-2 border">
                    <span><b>会員ID:</b></span>
                    <span className={`float-right pr-2 ${appState.qrcode_err && ' text-danger'}`}>{appState.qrcode_err ? appState.qrcode_err : appState.membership_id}</span>
                  </div>
                  <div className="card-header p-2 text-left border">
                    <span><b>保有ポイント:</b></span>
                    <span className="float-right pr-2"><b>{appState.available_point.toLocaleString()}</b> ポイント</span>
                  </div>
                  <div className="card-header p-2 text-left border">
                    <span><b>利用済みポイント:</b></span>
                    <span className="float-right pr-2"><b>{appState.use_point.toLocaleString()}</b> ポイント</span>
                  </div>
                  <div className="card-header p-2 text-left border">
                    <span><b>会員ランク:</b></span>
                    <span className="float-right pr-2"><b>{appState.customer_rank ? appState.customer_rank.rank_name : null}</b></span>
                  </div>
                  <div className="card-header p-2 text-left border">
                    <span><b>ポイント還元{appState.point_rate > 0 ? "率" : "基準額（税込み）"}:</b></span>
                    <span className="float-right pr-2"><b>{appState.point_rate ? Number(appState.point_rate) : appState.point_base_amount ? Number(appState.point_base_amount) : null}</b> {appState.point_rate > 0 ? "％" : "円に1ポイント"}</span>
                  </div>
                </div>
              </div>
              <div><div>
                <button className='btn btn-enable p-1' onClick={e => gotoPointHistory(appState.membership_id)}>ポイント履歴表示</button>
              </div></div>
              <div className="row">
                <div className="col my-3 text-left bg-white">
                  <PointBreakdown appState={appState} />
                </div>
              </div>
              {appState.pointCampaignList &&
                <div className="row">
                  <div className="col my-3 text-left bg-white">
                    <div className="card-header p-2 border">
                      <span><b>開催中の対象キャンペーン:</b></span>
                      <div className="row">
                        {appState.pointCampaignList.filter(x => (!Object.values(constClass.PAYMENT_METHOD).includes(x.payment_method.toString()) || !appState.paymentMethod || x.payment_method.toString() === appState.paymentMethod.toString()))
                          .map((item, idx) =>
                            <div className="col-12 pl-5 text-left" key={idx}>
                              {item.point_campaign_name}
                            </div>
                          )}
                      </div></div>
                  </div>
                </div>
              }
            </div>

            <div className="half full my-3 text-left bg-white mt-md-0 mt-4 mx-4">
              <table className="table">
                <tbody>
                  <tr>
                    <td className="p-0" height="60" colSpan="4"><Result result={appState.inputValue} /></td>
                  </tr>
                  <tr>
                    <td className="text-center" colSpan="4">
                      <div className='row'>
                        {appState.mall_id === 1 && Object.keys(constClass.PAYMENT_METHOD).map((p, idx) =>
                          constClass.PAYMENT_METHOD_NAME[p] !== 'SAKULaLa決済' && (
                            <div key={idx} className={`col-3 p-1`}>
                              <button
                                className={`btn ${appState.paymentMethod === constClass.PAYMENT_METHOD[p] ? "btn-active" : "btn-enable"} w-100 py-3`}
                                onClick={() => { handlePaymentMethod(constClass.PAYMENT_METHOD[p]) }}>
                                {constClass.PAYMENT_METHOD_NAME[p]}
                              </button>
                            </div>
                          )
                        )}
                        {appState.mall_id !== 1 && Object.keys(constClass.PAYMENT_METHOD).map((p, idx) =>
                          constClass.PAYMENT_METHOD_NAME[p] !== '現金・商品券' && constClass.PAYMENT_METHOD_NAME[p] !== 'SAKULaLa決済' && (           
                            <div key={idx} className={`col-3 p-1`}>
                              <button
                                className={`btn ${appState.paymentMethod === constClass.PAYMENT_METHOD[p] ? "btn-active" : "btn-enable"} w-100 py-3`}
                                onClick={() => { handlePaymentMethod(constClass.PAYMENT_METHOD[p]) }}>
                                {constClass.PAYMENT_METHOD_NAME[p]}
                              </button>
                            </div>
                          )
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr className='no-border'>
                    <td className="text-center no-border" colSpan="4">
                      <div className='row font-weight-bold'>
                        {appState.mall_id === 1 && "値引き前の税込み決済金額を入力"}
                        {appState.mall_id !== 1 && "値引き後の税込み決済金額を入力"}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"7"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"8"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"9"} /></td>
                    <td className="p-0" height="60" width="25%" rowSpan="2"><OperatorBtn className={"w-100 h-100"} t={"C"} /></td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"4"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"5"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"6"} /></td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"1"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"2"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"3"} /></td>
                    <td className="p-0" height="60" width="25%" rowSpan="2"><OperatorBtn className={"w-100 h-100"} t={"⏎"} disabled={appState.membership_id === null || appState.inputValue === 0} /></td>
                  </tr>
                  <tr>
                    <td className="p-0" height="60" colSpan="2"><NumBtn className={"w-100 h-100"} n={"0"} /></td>
                    <td className="p-0" height="60"><NumBtn className={"w-100 h-100"} n={"00"} /></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      }
      {appState.couponUseFlag &&
        <React.Fragment>
          <div className="row col-12">
            <div className='col-2'>
              <button type="button"
                className={`btn btn-secondary mx-1 w-100 text-nowrap`}
                onClick={() => { handleBackClick() }}>
                戻る
              </button>
            </div>
          </div>
          <div className="row">
            <div className='half full d-flex justify-content-center align-items-center my-3'>
              <div className='row mx-4'>
                {!appState.selectData.issue_count &&
                  <LiffTicket
                    ticket={appState.selectData}
                    preview={true}
                    couponPreview={true}
                    siteId={siteId}
                    mallId={String(appState.selectData.mall_id)}
                  />
                }
                {appState.selectData.issue_count && !appState.selectData.benefit_id &&
                  <LiffTicketIssue
                    ticket={appState.selectData}
                    preview={true}
                    couponPreview={true}
                    siteId={siteId}
                    mallId={String(appState.selectData.mall_id)}
                  />
                }
                {appState.selectData.issue_count && appState.selectData.benefit_id &&
                  <LiffBenefit
                    benefit={appState.selectData}
                    preview={true}
                    couponPreview={true}
                    siteId={siteId}
                    mallId={String(appState.mall_id)}
                  />
                }
              </div>
            </div>
            <div className='half full my-3 text-left bg-white mx-4'>
              <div className="row">
                <div className="col my-3 text-left bg-white">
                  <div className="card-header p-2 border">
                    <span><b>会員ID:</b></span>
                    <span className={`float-right pl-2 ${appState.qrcode_err && ' text-danger'}`}>{appState.qrcode_err ? appState.qrcode_err : appState.membership_id}</span>
                  </div>
                  <div className="card-header p-2 text-left border">
                    <span><b>保有ポイント:</b></span>
                    <span className="float-right pr-2"><b>{appState.available_point.toLocaleString()}</b> ポイント</span>
                  </div>
                  <div className="card-header p-2 text-left border">
                    <span><b>会員ランク:</b></span>
                    <span className="float-right pr-2"><b>{appState.customer_rank ? appState.customer_rank.rank_name : null}</b></span>
                  </div>
                  <div className="card-header p-2 text-left border">
                    <span><b>ポイント還元{appState.point_rate > 0 ? "率" : "基準額"}:</b></span>
                    <span className="float-right pr-2"><b>{appState.point_rate ? Number(appState.point_rate) : appState.point_base_amount ? Number(appState.point_base_amount) : null}</b> {appState.point_rate > 0 ? "％" : "円に1ポイント"}</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col my-3 text-left bg-white">
                  <div className="p-2 border-top">
                    <span className='pointfontsize'><b>保有ポイント</b></span>
                    <span className="float-right pl-2 pointfontsize">{appState.available_point.toLocaleString()} ポイント</span>
                  </div>
                  <div className="p-2 text-left border-top">
                    <span className='pointfontsize'><b>利用ポイント</b></span>
                    <span className="float-right pr-2 pointfontsize">{appState.use_point.toLocaleString()} ポイント</span>
                  </div>
                  <div className="p-2 text-left border-top border-bottom">
                    <span className='pointfontsize'><b>残りポイント</b></span>
                    <span className="float-right pr-2 pointfontsize">{(appState.available_point - appState.use_point).toLocaleString()} ポイント</span>
                  </div>
                </div>
              </div>
              {ticketGroupMessage &&
                <div className="text-right mb-2">
                  <span className="text-danger">{ticketGroupMessage}</span>
                </div>
              }
              {!appState.selectData.benefit_id && appState.selectData.issue_count && appState.selectData.use_date ? (
                <div className="text-right mb-2">
                  <span className="text-danger">既に使用しています。</span>
                </div>
              ) : !appState.selectData.benefit_id && !appState.selectData.issue_count && appState.selectData.ticket_times !== 0 && !Common.isTicketCountAvailable(appState.selectData) ? (
                <div className="text-right mb-2">
                  <span className="text-danger">ご利用の回数が上限を超えています。</span>
                </div>
              ) : null}
              <div className="text-right">
                <button
                  disabled={checkInvalid()}
                  className={`btn ${appState.pointUseFlag === false ? "btn-active" : "btn-enable"} w-50 h-100 p-3`}
                  onClick={() => handleCouponUseClick()}>
                  <b>{appState.use_point ? 'ポイント利用' : 'クーポン利用'}</b>
                </button>
              </div>
            </div>
          </div>
        </React.Fragment>
      }
    </div>
  );
};

export default Calculator;